module.exports = __webpack_public_path__ + "media/bell.34a49443.mp3";